var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("VueGoodTable", {
        attrs: {
          columns: _vm.columnsConfig,
          rows: _vm.rows,
          paginationOptions: _vm.paginationOptions,
          searchOptions: _vm.searchOptions
        },
        scopedSlots: _vm._u([
          {
            key: "table-row",
            fn: function(props) {
              return [
                props.column.field === "actions"
                  ? _c("div", { staticClass: "btn-group" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-danger",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.removeAccount(props.row)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-trash" })]
                      )
                    ])
                  : _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.formattedRow[props.column.field]) +
                          "\n      "
                      )
                    ])
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-row mt-2" }, [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newAccountId,
                expression: "newAccountId"
              }
            ],
            staticClass: "form-control",
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.newAccountId = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              }
            }
          },
          _vm._l(_vm.accountSelect?.parentList, function(o) {
            return _c("option", { key: o.dbId, domProps: { value: o.dbId } }, [
              _vm._v(_vm._s(o.path + o.text))
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-success ml-2",
            attrs: { type: "button", disabled: !_vm.newAccountId },
            on: { click: _vm.addAccount }
          },
          [_vm._v(_vm._s(_vm.$t("btnAdd")))]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }